import { useEffect, useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
  Tbody,
} from "@chakra-ui/react";
import {
  AddIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import API, { getMediaURL } from "../../context/API";
import { GrUpdate } from "react-icons/gr";
import { Reorder } from "framer-motion";
import MultiSelectDropdown from "./merchantdropdown.js";

const MerchantCategories = () => {
  const [categories, setCategories] = useState([]);
  // const [selectedItems, setSelectedItems] = useState([]); // State for selected items
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false); // Separate state for refresh loading
  const [merchants, setMerchants] = useState([]);
  const [currentCategory, setCurrentCategory] = useState({
    category: "",
    picture: "",
    merchant: [],
  });
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const toast = useToast();

  const [imageFile, setImageFile] = useState(null);
  const imageInputRef = useRef(null);

  // Add a ref to track the order of categories
  const [categoryOrder, setCategoryOrder] = useState([]);

  useEffect(() => {
      fetchCategories();
      fetchMerchants();
  }, []);
  // Fetch merchants from API (Admin Only)
    const fetchMerchants = async () => {
      try {
        const token = localStorage.getItem("access_token");
  
        const response = await API.get(`/merchant`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.data.success) {
          const fetchedMerchants = response.data.data || [];
          setMerchants(fetchedMerchants);
        } else {
          setMerchants([]);
        }
      } catch (error) {
        console.error("Error fetching merchants:", error);
        setMerchants([]);
      }
    };

  const fetchCategories = async () => {
    setRefreshing(true);
    try {
      const response = await API.get("/merchant-categories");
      
      const categoriesData = response.data.data.map((category) => {
  
        return {
          ...category,
          picture: getMediaURL(category.picture), 
          merchant: category.merchant?.map((merchant) => merchant.id) || [],
        };
      });
  
      categoriesData.sort((a, b) => a.sequence_number - b.sequence_number);
  
      setCategories(categoriesData);
      setCategoryOrder(categoriesData.map((cat) => cat.id));
  
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  // const handleRemoveSelectedItem = (itemId) => {
  //   setSelectedItems(selectedItems.filter((item) => item.id !== itemId));
  // };

  const handleEdit = async (category) => {
    setCurrentCategory(category);
    setImageFile(null); // Reset image file state

    onOpen();
  };

  const handleCreate = () => {
    setCurrentCategory({
      category: "",
      picture: "",
      merchant: [],});
    // setSelectedItems([]); // Reset selected items

    setImageFile(null); // Reset image file state
    onOpen();
  };

  const handleDelete = (id) => {
    setCurrentCategory({ ...currentCategory, id });
    setIsDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await API.delete(`/merchant-categories/${currentCategory.id}`);
      
      // Immediate local state update
      setCategories(prevCategories => 
        prevCategories.filter(cat => cat.id !== currentCategory.id)
      );
      setCategoryOrder(prevOrder => 
        prevOrder.filter(id => id !== currentCategory.id)
      );
      
      toast({
        title: "Category deleted.",
        description: "The category has been deleted successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      
      // Refresh from API to ensure consistency
      fetchCategories();
    } catch (error) {
      toast({
        title: "Error deleting category.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleteDialogOpen(false);
    }
  };
  // const handleImageUpload = async (file) => {
  //   const compressedFile = await getCompressedFile(file)
  //   const formData = new FormData();
  //   formData.append("file", compressedFile);
  //   formData.append("type", "kiwikiosk_categories");

  //   try {
  //     const response = await API.post("/images/upload", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     const fullUrl = response.data.url;
  //     const relativePath = cleanPicturePath(fullUrl);
  //     return relativePath;
  //   } catch (error) {
  //     console.error('Error uploading image:', error);
  //     const errorMessage = error.response?.data?.message || error.response?.data || "Unable to upload the image.";
  
  //     toast({
  //       title: "Image Upload Failed.",
  //       description: errorMessage,
  //       status: "error",
  //       duration: 5000,
  //       isClosable: true,
  //     });
  //     return null;
  //   }
  // };

  // const handleImageReplace = async (imageKey, file) => {
  //   const compressedFile =await getCompressedFile(file)
  //   const formData = new FormData();
  //   formData.append("file", compressedFile);
  //   formData.append("type", "kiwikiosk_categories");

  //   try {
  //     const encodedImageKey = encodeURIComponent(imageKey);
  //     const response = await API.put(`/images/${encodedImageKey}`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     const fullUrl = response.data.url;
  //     const relativePath = cleanPicturePath(fullUrl);
  //     return relativePath;
  //   } catch (error) {
  //     console.error('Error replacing image:', error);
  //     const errorMessage = error.response?.data?.message || error.response?.data || "Unable to replace the image.";
  
  //     toast({
  //       title: "Image Replace Failed.",
  //       description: errorMessage,
  //       status: "error",
  //       duration: 5000,
  //       isClosable: true,
  //     });
  //     return null;
  //   }
  // };


  const handleSubmit = async () => {
    if (imageFile || currentCategory.picture) {
        const formData = new FormData();
        // Append the image file to FormData 
        if(imageFile){
            formData.append("picture", imageFile)
        }
        formData.append("category", currentCategory.category);
        formData.append("merchant", currentCategory.merchant); 
      // const formattedCategoryData = {
      //   ...currentCategory,
      //   category: currentCategory.category,
      //   picture: currentCategory.picture || imageFile, // Only store the end path
      //   merchant: currentCategory.merchant,
      // };
      try {
        if (currentCategory.id) {
          await API.put(
            `/merchant-categories/${currentCategory.id}`,
            formData,
            {
                headers: {
                  "Content-Type": "multipart/form-data", // Ensure proper content type for FormData
                },
              }
          );
          toast({
            title: "Category updated.",
            description: "The category has been updated successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } else {
          await API.post("/merchant-categories", formData, {
            headers: {
              "Content-Type": "multipart/form-data", // Ensure proper content type for FormData
            },
          });
          toast({
            title: "Category created.",
            description: "The category has been created successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });

        }
        fetchCategories(); // Refresh the list
        onClose();
      } catch (error) {
        console.error("Error saving category:", error);
        let errorMessage =
          error.response?.data?.message ||
          error.response?.data ||
          "Unable to save the category.";

        // Check and replace specific error messages
        if (errorMessage.includes("value too long for type")) {
          errorMessage = "The image file name is too long.";
        }

        toast({
          title: "An error occurred.",
          description: errorMessage,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  // Handle reorder of categories
  const handleReorder = async (newOrder) => {
    setCategoryOrder(newOrder);

    // Update categories with new sequence numbers
    const reorderedCategories = newOrder.map((id, index) => {
      const category = categories.find((cat) => cat.id === id);
      return {
        ...category,
        sequence_number: index + 1,
      };
    });

    setCategories(reorderedCategories);

    // Send updated sequence numbers to the backend
    try {
      await Promise.all(
        reorderedCategories.map((category) =>
          API.put(`/merchant-categories/${category.id}`, {
            id: category.id,
            category: category.category,
            //picture: category.picture.replace(getMediaURL(''), ''), // Adjust picture path
            sequence_number: category.sequence_number,
            items: category.items,
          })
        )
      );
      toast({
        title: "Categories reordered.",
        description: "The categories have been reordered successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error updating sequence numbers:", error);
      toast({
        title: "Error updating order.",
        description: "Unable to update the category order.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const bgColor = useColorModeValue("white", "gray.800");
  const selectedBgColor = useColorModeValue("gray.200", "gray.600");

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Box my={"4"}>
      <Flex justify="space-between" align="center" marginBottom="4">
        <Box>
          <Heading size={"xl"} letterSpacing={-2}>
            Categories
          </Heading>
          <Text fontSize={"sm"}>
            List of all available categories, you can add new ones, edit and/or
            delete older ones.
          </Text>
        </Box>
        <Button
          display={{ base: "none", md: "flex" }} // Hide on mobile, show on larger screens
          leftIcon={<AddIcon />}
          bg="black"
          color={"white"}
          _hover={{
            color: "black",
            bg: "white",
            borderWidth: "1px",
            borderColor: "gray.300",
          }}
          variant="outline"
          onClick={handleCreate}
        >
          Create Category
        </Button>
        <IconButton
          display={{ base: "flex", md: "none" }} // Show icon button on mobile
          icon={<AddIcon />}
          size="sm"
          aria-label="Create Category"
          bg="black"
          color={"white"}
          _hover={{
            color: "black",
            bg: "white",
            borderWidth: "1px",
            borderColor: "gray.300",
          }}
          onClick={handleCreate}
        />
      </Flex>
      <Box p={4} bg={bgColor} borderRadius="md" overflowX="auto">
        <Table variant="simple" minWidth="600px">
          <Thead>
            <Tr>
              <Th>Category</Th>
              <Th>Picture</Th>
              <Th textAlign={"center"}>Actions</Th>
            </Tr>
          </Thead>
          {refreshing ? (
          <Tbody>
            <Tr>
              <Td colSpan="5">
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  height="150px"
                >
                  <Spinner size="lg" />
                </Flex>
              </Td>
            </Tr>
            </Tbody>
          ) : (
            <Reorder.Group
              as="tbody"
              axis="y"
              values={categoryOrder}
              onReorder={handleReorder}
            >
              {categoryOrder.map((id) => {
                const category = categories.find((cat) => cat.id === id);
                if (!category) return null;
                return (
                  <Reorder.Item
                    as="tr"
                    key={id}
                    value={id}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 1.01 }}
                    style={{ 
                      cursor: "grab",
                      backgroundColor: category.id === currentCategory.id ? selectedBgColor : bgColor
                    }}
                  >
                    <Td>{category.category}</Td>
                    <Td>
                      {category.picture && (
                        <Image
                          src={category.picture}
                          alt={category.category}
                          boxSize="50px"
                          objectFit="cover"
                          borderRadius="md"
                          fallbackSrc="https://via.placeholder.com/50"
                        />
                      )}
                    </Td>
                    <Td>
                      <Flex justifyContent="center">
                        <IconButton
                          icon={<EditIcon />}
                          colorScheme="blue"
                          variant="ghost"
                          aria-label="Edit Category"
                          onClick={() => handleEdit(category)}
                        />
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          variant="ghost"
                          aria-label="Delete Category"
                          onClick={() => handleDelete(category.id)}
                        />
                      </Flex>
                    </Td>
                  </Reorder.Item>
                );
              })}
            </Reorder.Group>
          )}
        </Table>
      </Box>

      {/* Modal for Creating/Updating Category */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size={{ base: "full", md: "lg", lg: "4xl" }} // Responsive modal sizes
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {currentCategory.id ? "Update Category" : "Create Category"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl id="category" mb="4">
              <FormLabel>Category Name</FormLabel>
              <Input
                placeholder="Enter category name"
                value={currentCategory.category}
                onChange={(e) =>
                  setCurrentCategory({
                    ...currentCategory,
                    category: e.target.value,
                  })
                }
              />
            </FormControl>
            <FormControl id="picture" mb="4">
              <FormLabel>Photo</FormLabel>
              <Box position="relative">
                <Image
                  src={
                    imageFile
                      ? URL.createObjectURL(imageFile)
                      : currentCategory.picture
                      ? currentCategory.picture
                      : "https://via.placeholder.com/320x240"
                  }
                  alt="Category Image"
                  width="100%"
                  height="300"
                  objectFit="cover"
                  borderRadius="md"
                  fallbackSrc="https://via.placeholder.com/320x240"
                />
                <Button
                  onClick={() => imageInputRef.current.click()}
                  position="absolute"
                  leftIcon={currentCategory.id ? <GrUpdate /> : <AddIcon />}
                  bg="black"
                  color={"white"}
                  _hover={{
                    color: "black",
                    bg: "white",
                    borderWidth: "1px",
                    borderColor: "gray.300",
                  }}
                  variant="outline"
                  top="2"
                  right="2"
                  size={"sm"}
                  borderRadius={"full"}
                >
                  {currentCategory.id ? "Change image" : "Add image"}
                </Button>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  ref={imageInputRef}
                  style={{ display: "none" }}
                />
              </Box>
              <Text fontSize="sm" color="gray.500" mt={2}>
                File requirement: JPG, PNG, GIF, or WEBP up to 10 MB. Minimum
                pixels required: 320 for width and height.
              </Text>
            </FormControl>
            <MultiSelectDropdown
                merchants={merchants}
                currentCategory={currentCategory}
                setCurrentCategory={setCurrentCategory}
                />
          </ModalBody>
          <ModalFooter>
            <Button
              bg="black"
              color={"white"}
              _hover={{
                color: "black",
                bg: "white",
                borderWidth: "1px",
                borderColor: "gray.300",
              }}
              variant="outline"
              mr={"3"}
              onClick={handleSubmit}
            >
              {currentCategory.id ? "Update Category" : "Create Category"}
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Alert dialog box for deleting confirmation */}
      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Category
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => setIsDeleteDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default MerchantCategories;
